import { faker } from '@faker-js/faker';
import { PatientProfile, PatientGender } from '@qmd-types/patient';
import dayjs from 'dayjs';

export default function getPatientProfileFixture(
  params?: Partial<PatientProfile>,
): PatientProfile {
  return {
    address: {
      streetAddress1: faker.location.streetAddress(),
      streetAddress2: faker.location.secondaryAddress(),
      city: faker.location.city(),
      stateCode: faker.location.state({ abbreviated: true }),
      zip: faker.location.zipCode('#####'),
      countryCode: faker.location.countryCode(),
    },
    birthDate: dayjs(
      faker.date.birthdate({ min: 1950, max: 2000, mode: 'year' }),
    ).format('YYYY-MM-DD'),
    creditAmount: faker.number.int({ min: 0, max: 100 }),
    email: faker.internet.email(),
    firstName: faker.person.firstName(),
    gender: faker.helpers.arrayElement([
      PatientGender.FEMALE,
      PatientGender.MALE,
    ]),
    genderIdentity: faker.helpers.arrayElement([
      'male',
      'female',
      'non-binary',
      'other',
    ]),
    hasMobileApp: faker.datatype.boolean(),
    hasTreatAccount: faker.datatype.boolean(),
    hasVisits: faker.datatype.boolean(),
    heightInches: faker.number.int({ min: 48, max: 84 }),
    identityVerification: {
      isCompleted: faker.datatype.boolean(),
      isLegacyCompleted: faker.datatype.boolean(),
      isCompletedWithErrors: faker.datatype.boolean(),
      remainingAttemptsCount: faker.number.int({ min: 0, max: 3 }),
      expireDate: null,
    },
    createDateTimeUtc: dayjs().toISOString(),
    isStateRequireDrugScreen: faker.datatype.boolean(),
    imageUrl: faker.image.avatar(),
    lastName: faker.person.lastName(),
    maritalStatus: faker.helpers.arrayElement([
      'annulled',
      'divorced',
      'legallyseparated',
      'married',
      'polygamous',
      'nevermarried',
      'domesticpartner',
      'single',
      'widowed',
      'prefernottosay',
    ]),
    medicalRecordNumber: faker.string.uuid(),
    patientId: faker.string.uuid(),
    phoneNumber: {
      countryCode: faker.location.countryCode(),
      number: faker.phone.number().replace('-', ''),
      prefix: '1',
    },
    preferredName: faker.person.firstName(),
    racialBackground: faker.helpers.arrayElement([
      'americanindianalaskanative',
      'asian',
      'blackafricanamerican',
      'caucasian',
      'hispaniclatino',
      'nativehawaiianpacificislander',
      'prefernottosay',
    ]),
    referralCode: faker.datatype.boolean() ? faker.string.uuid() : null,
    referralCreditAmount: faker.datatype.boolean()
      ? faker.number.int({ min: 0, max: 100 })
      : null,
    unreadNotificationsCount: faker.number.int({ min: 0, max: 5 }),
    weightPounds: faker.number.int({ min: 100, max: 300 }),
    pharmacy: null,
    ...params,
  };
}
